(function () {
  if (window.MokaeProFormSheetSyncLoaded) return;
  window.MokaeProFormSheetSyncLoaded = true;

  var WEBHOOK_URL =
    'https://script.google.com/macros/s/AKfycbwchN_59Au5CuRjNDCSL6_PQkX1Bnk5BHsnGd2bTdh6xMKfv1CSjGq6VUy5UlSI-kClBA/exec';

  var FORMS = {
    '95799': {
      shortcode: 'OTU3OTk=',
      gid: '632393807',
      sheet: 'Mokae Pro Circle AContact form',
      customerTag: 'Mokae Pro Subscriber'
    },
    '146734': {
      shortcode: 'MTQ2NzM0',
      gid: '532049349',
      sheet: 'Mokae Pro Inner Circle form (1)',
      customerTag: 'Mokae Pro Invitee'
    }
  };

  var ELEMENT_KEYS = {
    'text-1': 'name',
    'email-1': 'email',
    'phone-1': 'phone',
    'url-1': 'professional_instagram_link',
    'checkbox-1': 'favourite_product',
    'number-1': 'experience_years',
    'url-2': 'portfolio_link',
    'checkbox-2': 'eligibility_criteria',
    'file2-1': 'upload_document_1',
    'file2-2': 'upload_document_2',
    'file2-3': 'upload_document_3',
    'file2-4': 'upload_photo_identification',
    'textarea-1': 'address'
  };

  var syncedKeys = {};
  var MAX_MIRROR_BYTES = 12 * 1024 * 1024;

  /* ── Global store: survives DOM re-renders ── */
  // formDataCaptures[formId] = { fields: {...}, at: timestamp }
  var formDataCaptures = {};

  function normalize(text) {
    return String(text || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isHttpUrl(value) {
    return /^https?:\/\//i.test(String(value || '').trim());
  }

  function uniqueUrls(values) {
    var seen = {};
    var out = [];
    values.forEach(function (value) {
      value = String(value || '').trim();
      if (!isHttpUrl(value) || seen[value]) return;
      seen[value] = true;
      out.push(value);
    });
    return out;
  }

  function extractUrls(value) {
    var urls = [];
    if (value == null) return urls;
    if (typeof value === 'string') {
      if (isHttpUrl(value)) urls.push(value);
      return urls;
    }
    if (Array.isArray(value)) {
      value.forEach(function (item) { urls = urls.concat(extractUrls(item)); });
      return urls;
    }
    if (typeof value === 'object') {
      ['url', 'fileUrl', 'file_url', 'src', 'href', 'path', 'value', 'link'].forEach(function (prop) {
        if (value[prop]) urls = urls.concat(extractUrls(value[prop]));
      });
    }
    return urls;
  }

  function decodeFormId(value) {
    if (!value) return '';
    if (FORMS[value]) return value;
    try {
      var decoded = window.atob(value);
      return FORMS[decoded] ? decoded : '';
    } catch (err) {
      return '';
    }
  }

  function getFormIdFromForm(formEl) {
    if (!formEl) return '';
    var action = formEl.action || '';
    var match = action.match(/\/form\/(\d+)\/send/);
    if (match && FORMS[match[1]]) return match[1];
    return '';
  }

  function getFormId(root) {
    var classMatch = String(root.className || '').match(/globo-form-id-(\d+)/);
    if (classMatch && FORMS[classMatch[1]]) return classMatch[1];

    var shortcode = root.matches && root.matches('.globo-formbuilder[data-id]')
      ? root
      : root.querySelector && root.querySelector('.globo-formbuilder[data-id]');
    if (shortcode) return decodeFormId(shortcode.getAttribute('data-id'));

    var idNode = root.querySelector && root.querySelector('[class*="globo-form-id-"]');
    if (idNode) {
      var m = String(idNode.className || '').match(/globo-form-id-(\d+)/);
      if (m && FORMS[m[1]]) return m[1];
    }

    var formEl = root.querySelector && root.querySelector('form');
    if (formEl) return getFormIdFromForm(formEl);

    return '';
  }

  /* ── CAPTURE METHOD 1: Document-level submit event (most reliable) ── */
  /* Fires BEFORE Globo's handler, reads FormData directly from the form */
  function captureFormData(formEl, formId) {
    var fields = {};
    try {
      var fd = new FormData(formEl);
      fd.forEach(function (value, key) {
        var baseKey = key.replace(/\[\]$/, '');
        if (!ELEMENT_KEYS[baseKey]) return;
        var payloadKey = ELEMENT_KEYS[baseKey];

        // Skip File objects (handled by mirror upload)
        if (typeof File !== 'undefined' && value instanceof File) {
          if (value.size > 0 && value.name) {
            // Don't overwrite URLs already captured by mirror
            if (!fields[payloadKey] || !isHttpUrl(fields[payloadKey])) {
              fields[payloadKey] = fields[payloadKey] || '';
            }
          }
          return;
        }

        var sv = String(value || '').trim();
        if (!sv) return;

        if (fields[payloadKey]) {
          // Append (for checkboxes with multiple values)
          if (fields[payloadKey].indexOf(sv) === -1) {
            fields[payloadKey] += ', ' + sv;
          }
        } else {
          fields[payloadKey] = sv;
        }
      });
    } catch (err) {
      // FormData constructor failed, fall back to DOM reading
    }

    // Also read from DOM directly as backup
    var inputs = formEl.querySelectorAll('input, select, textarea');
    inputs.forEach(function (field) {
      if (!field || field.disabled) return;
      if (field.type === 'button' || field.type === 'submit' || field.type === 'hidden') return;

      var name = (field.getAttribute('name') || '').replace(/\[\]$/, '');
      var payloadKey = ELEMENT_KEYS[name];
      if (!payloadKey) return;

      if (field.type === 'checkbox' || field.type === 'radio') {
        if (!field.checked) return;
        var cv = (field.value || 'Yes').trim();
        if (!cv) return;
        if (fields[payloadKey]) {
          if (fields[payloadKey].indexOf(cv) === -1) {
            fields[payloadKey] += ', ' + cv;
          }
        } else {
          fields[payloadKey] = cv;
        }
        return;
      }

      if (field.type === 'file') return;

      var v = (field.value || '').trim();
      if (v && !fields[payloadKey]) {
        fields[payloadKey] = v;
      }
    });

    if (Object.keys(fields).length > 0) {
      // MERGE into existing — never overwrite accumulated data from earlier wizard steps
      var existing = formDataCaptures[formId] || { fields: {}, at: 0 };
      Object.keys(fields).forEach(function (k) {
        if (fields[k]) existing.fields[k] = fields[k];
      });
      existing.at = Date.now();
      formDataCaptures[formId] = existing;
    }
  }

  function installSubmitCapture() {
    if (window.__mokaeProSubmitCapture) return;
    window.__mokaeProSubmitCapture = true;

    // Capture phase on document — fires BEFORE any other handler
    document.addEventListener('submit', function (e) {
      var formEl = e.target;
      if (!formEl || formEl.tagName !== 'FORM') return;

      var formId = getFormIdFromForm(formEl);
      if (!formId) return;

      captureFormData(formEl, formId);
    }, true); // true = capture phase
  }

  /* ── CAPTURE METHOD 2: Click on submit button ── */
  function installClickCapture() {
    if (window.__mokaeProClickCapture) return;
    window.__mokaeProClickCapture = true;

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest
        ? e.target.closest('button[type="submit"], .wizard__submit, .action.submit, input[type="submit"], .wizard__next, .action.next, .action.previous')
        : null;
      if (!btn) return;

      // Find form — try within Globo container first, then closest
      var formEl = btn.closest('form');
      if (!formEl) {
        var container = btn.closest('.globo-formbuilder, .globo-form-app, [class*="globo-form-id-"]');
        if (container) formEl = container.querySelector('form');
      }
      if (!formEl) return;

      var formId = getFormIdFromForm(formEl);
      if (!formId) return;

      // Capture on ANY wizard button click (Next, Previous, Submit)
      captureFormData(formEl, formId);
    }, true); // capture phase
  }

  /* ── CAPTURE METHOD 3: Network interception (fetch + XHR) ── */
  function captureFromRequestBody(formId, body) {
    if (!body || !formId || !FORMS[formId]) return;

    var fields = {};

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      body.forEach(function (value, key) {
        var baseKey = key.replace(/\[\]$/, '');
        if (!ELEMENT_KEYS[baseKey]) return;
        var payloadKey = ELEMENT_KEYS[baseKey];
        if (typeof File !== 'undefined' && value instanceof File) return;
        var sv = String(value || '').trim();
        if (!sv) return;
        if (fields[payloadKey]) {
          if (fields[payloadKey].indexOf(sv) === -1) fields[payloadKey] += ', ' + sv;
        } else {
          fields[payloadKey] = sv;
        }
      });
    } else {
      var parsed = null;
      if (typeof body === 'string') {
        try { parsed = JSON.parse(body); } catch (err) {}
      } else if (typeof body === 'object') {
        parsed = body;
      }
      if (parsed) {
        walkObject(parsed, function (node) {
          if (!node || typeof node !== 'object' || Array.isArray(node)) return;
          Object.keys(node).forEach(function (key) {
            var baseKey = key.replace(/\[\]$/, '');
            if (!ELEMENT_KEYS[baseKey]) return;
            var payloadKey = ELEMENT_KEYS[baseKey];
            var val = node[key];
            var urls = uniqueUrls(extractUrls(val));
            if (urls.length) { fields[payloadKey] = urls.join('\n'); return; }
            if (val != null && !fields[payloadKey]) {
              if (Array.isArray(val)) {
                var items = val.map(function (v) {
                  if (typeof v === 'string' || typeof v === 'number') return String(v).trim();
                  if (v && typeof v === 'object' && v.label) return String(v.label).trim();
                  if (v && typeof v === 'object' && v.value) return String(v.value).trim();
                  return '';
                }).filter(Boolean);
                if (items.length) fields[payloadKey] = items.join(', ');
              } else if (typeof val === 'string' || typeof val === 'number') {
                var sv = String(val).trim();
                if (sv) fields[payloadKey] = sv;
              }
            }
          });
        });
      }
    }

    if (Object.keys(fields).length > 0) {
      // Merge into existing capture (don't overwrite with less data)
      var existing = formDataCaptures[formId] || { fields: {}, at: 0 };
      Object.keys(fields).forEach(function (k) {
        if (fields[k]) existing.fields[k] = fields[k];
      });
      existing.at = Date.now();
      formDataCaptures[formId] = existing;
    }
  }

  function walkObject(node, visitor) {
    if (node == null) return;
    visitor(node);
    if (Array.isArray(node)) {
      node.forEach(function (item) { walkObject(item, visitor); });
      return;
    }
    if (typeof node === 'object') {
      Object.keys(node).forEach(function (key) { walkObject(node[key], visitor); });
    }
  }

  function installNetworkHooks() {
    if (window.__mokaeProNetworkHook) return;
    window.__mokaeProNetworkHook = true;

    if (window.fetch) {
      var originalFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var match = url.match(/\/api\/front\/form\/(\d+)\/send/);
        if (match && init && init.body) {
          captureFromRequestBody(match[1], init.body);
        }
        return originalFetch(input, init);
      };
    }

    if (window.XMLHttpRequest) {
      var originalOpen = XMLHttpRequest.prototype.open;
      var originalSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__mokaeProUrl = url || '';
        return originalOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function (body) {
        var match = String(this.__mokaeProUrl || '').match(/\/api\/front\/form\/(\d+)\/send/);
        if (match && body) {
          captureFromRequestBody(match[1], body);
        }
        return originalSend.apply(this, arguments);
      };
    }
  }

  /* ── CAPTURE METHOD 4: Continuous input tracking ── */
  function installInputCapture() {
    if (window.__mokaeProInputCapture) return;
    window.__mokaeProInputCapture = true;

    // Track inputs at document level — survives DOM re-renders
    document.addEventListener('input', function (e) {
      var field = e.target;
      if (!field) return;
      var formEl = field.closest('form');
      if (!formEl) return;
      var formId = getFormIdFromForm(formEl);
      if (!formId) return;

      var name = (field.getAttribute('name') || '').replace(/\[\]$/, '');
      var payloadKey = ELEMENT_KEYS[name];
      if (!payloadKey) return;

      var value = (field.value || '').trim();
      if (!value) return;

      var capture = formDataCaptures[formId] || { fields: {}, at: 0 };
      capture.fields[payloadKey] = value;
      capture.at = Date.now();
      formDataCaptures[formId] = capture;
    }, true);

    document.addEventListener('change', function (e) {
      var field = e.target;
      if (!field) return;
      var formEl = field.closest('form');
      if (!formEl) return;
      var formId = getFormIdFromForm(formEl);
      if (!formId) return;

      // For checkboxes, re-read ALL checkboxes with same name
      if (field.type === 'checkbox') {
        var name = (field.getAttribute('name') || '').replace(/\[\]$/, '');
        var payloadKey = ELEMENT_KEYS[name];
        if (!payloadKey) return;

        var allCbs = formEl.querySelectorAll('[name="' + field.getAttribute('name') + '"]');
        var checked = [];
        allCbs.forEach(function (cb) {
          if (cb.checked) checked.push((cb.value || 'Yes').trim());
        });
        var capture = formDataCaptures[formId] || { fields: {}, at: 0 };
        if (checked.length) {
          capture.fields[payloadKey] = checked.join(', ');
        }
        // Don't delete existing data if none checked — wizard may have hidden the step
        capture.at = Date.now();
        formDataCaptures[formId] = capture;
        return;
      }

      // For file inputs, trigger mirror upload
      if (field.type === 'file' && field.files && field.files.length) {
        handleFileSelection(formEl, formId, field);
        return;
      }

      // For other fields
      var name2 = (field.getAttribute('name') || '').replace(/\[\]$/, '');
      var payloadKey2 = ELEMENT_KEYS[name2];
      if (!payloadKey2) return;
      var value2 = (field.value || '').trim();
      if (value2) {
        var capture2 = formDataCaptures[formId] || { fields: {}, at: 0 };
        capture2.fields[payloadKey2] = value2;
        capture2.at = Date.now();
        formDataCaptures[formId] = capture2;
      }
    }, true);
  }

  /* ── File upload mirroring ── */
  function createUploadToken() {
    return String(Date.now()) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function readFileAsBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        var result = String(reader.result || '');
        resolve(result.split(',')[1] || '');
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  var mirrorUrls = {};       // fieldKey → url
  var uploadPromises = [];

  function findPayloadKeyForFileInput(input) {
    var name = (input.getAttribute('name') || '').replace(/\[\]$/, '');
    if (ELEMENT_KEYS[name]) return ELEMENT_KEYS[name];

    var control = input.closest('.globo-form-control, .gfb__field, .form-group, .field');
    var haystack = [input.name, input.id,
      control && control.getAttribute('data-id'),
      control && control.id, control && control.className
    ].join(' ').toLowerCase();

    for (var eid in ELEMENT_KEYS) {
      if (eid.indexOf('file2-') === 0 && haystack.indexOf(eid) !== -1) {
        return ELEMENT_KEYS[eid];
      }
    }
    return '';
  }

  function pollMirrorUpload(uploadToken) {
    return new Promise(function (resolve, reject) {
      var attempts = 0;
      function tick() {
        attempts += 1;
        fetch(WEBHOOK_URL + '?action=get_mirror_upload&upload_token=' + encodeURIComponent(uploadToken),
          { method: 'GET', credentials: 'omit' })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.success && data.url) { resolve(data.url); return; }
            if (data && data.pending) {
              if (attempts >= 45) { reject(new Error('timeout')); return; }
              window.setTimeout(tick, 1000); return;
            }
            reject(new Error((data && data.error) || 'failed'));
          })
          .catch(function (err) {
            if (attempts >= 45) { reject(err); return; }
            window.setTimeout(tick, 1000);
          });
      }
      window.setTimeout(tick, 500);
    });
  }

  function mirrorFileToDrive(formId, fieldKey, file) {
    if (!file || !fieldKey || file.size > MAX_MIRROR_BYTES) return Promise.resolve('');
    var uploadToken = createUploadToken();
    var p = readFileAsBase64(file)
      .then(function (base64) {
        if (!base64) throw new Error('Could not read file.');
        return fetch(WEBHOOK_URL, {
          method: 'POST', mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({
            action: 'mirror_upload', upload_token: uploadToken,
            form_id: formId, field_key: fieldKey,
            filename: file.name, mime_type: file.type || 'application/octet-stream',
            data_base64: base64
          }),
          keepalive: true
        }).then(function () { return pollMirrorUpload(uploadToken); });
      })
      .then(function (url) { mirrorUrls[fieldKey] = url; return url; })
      .catch(function () { return ''; });
    uploadPromises.push(p);
    return p;
  }

  function handleFileSelection(formEl, formId, input) {
    if (!input || !input.files || !input.files.length) return;
    var fieldKey = findPayloadKeyForFileInput(input);
    if (!fieldKey || fieldKey.indexOf('upload_') !== 0) return;
    Array.prototype.forEach.call(input.files, function (file) {
      mirrorFileToDrive(formId, fieldKey, file);
    });
  }

  /* ── Build final payload and send ── */
  function buildPayload(formId) {
    var config = FORMS[formId];
    if (!config) return null;

    var payload = {
      mode: 'pro',
      sheet: config.sheet,
      gid: config.gid,
      form_id: formId,
      form_shortcode: config.shortcode,
      customer_tag: config.customerTag,
      status: 'New',
      page_url: window.location.href.split('#')[0]
    };

    // Merge all captured field data
    var capture = formDataCaptures[formId];
    if (capture && capture.fields) {
      Object.keys(capture.fields).forEach(function (key) {
        var val = capture.fields[key];
        if (val && String(val).trim()) payload[key] = String(val).trim();
      });
    }

    // Merge mirror upload URLs
    Object.keys(mirrorUrls).forEach(function (key) {
      var url = String(mirrorUrls[key] || '').trim();
      if (isHttpUrl(url)) payload[key] = url;
    });

    return payload;
  }

  function buildQueryUrl(payload) {
    var url = new URL(WEBHOOK_URL);
    Object.keys(payload).forEach(function (key) {
      var value = payload[key];
      if (value !== undefined && value !== null && String(value).length) {
        url.searchParams.set(key, String(value));
      }
    });
    return url.toString();
  }

  function submitSheet(formId) {
    var payload = buildPayload(formId);
    if (!payload) return;
    if (!payload.email && !payload.name) return;

    var key = formId + '|' + normalize(payload.email || payload.name);
    if (syncedKeys[key]) return;
    syncedKeys[key] = true;

    var body = JSON.stringify(payload);

    fetch(WEBHOOK_URL, {
      method: 'POST', mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: body, keepalive: true
    }).catch(function () { syncedKeys[key] = false; });

    if (body.length < 7000) {
      fetch(buildQueryUrl(payload), { method: 'GET', mode: 'no-cors', keepalive: true }).catch(function () {});
    }
  }

  function queueSubmit(formId) {
    var pending = uploadPromises.slice();
    var doSend = function () { submitSheet(formId); };

    if (pending.length) {
      Promise.all(pending).catch(function () {}).then(doSend);
    } else {
      doSend();
    }
  }

  /* ── Watch for Globo success message ── */
  function wasSuccessful(root) {
    return !!root.querySelector(
      '.message.success, .globo-form-app .message.success, .gfb__content-title'
    );
  }

  function watchForSuccess() {
    if (window.__mokaeProSuccessWatch) return;
    window.__mokaeProSuccessWatch = true;

    var submitted = {};

    var observer = new MutationObserver(function () {
      document.querySelectorAll('.globo-formbuilder, .globo-form-app, [class*="globo-form-id-"]').forEach(function (node) {
        if (!wasSuccessful(node)) return;

        var formId = getFormId(node);
        if (!formId) return;
        if (submitted[formId]) return;

        // Check we have captured data
        var capture = formDataCaptures[formId];
        if (!capture || Date.now() - capture.at > 120000) return;

        submitted[formId] = true;

        // Wait a moment for any pending mirror uploads, then send
        window.setTimeout(function () {
          queueSubmit(formId);
          // Reset for next submission
          window.setTimeout(function () { submitted[formId] = false; }, 5000);
        }, 500);
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  }

  /* ── Initialize everything ── */
  installSubmitCapture();
  installClickCapture();
  installInputCapture();
  installNetworkHooks();
  watchForSuccess();
})();